<template>
  <div class="mb-6">
    <!-- Label -->
    <label :for="id" class="block w-full mb-1">
      {{ label }}
    </label>

    <div class="relative">
      <select
        :id="id"
        :value="value"
        class="block w-full border border-nucleus-darkestBlue rounded p-2 bg-nucleus-lightestBlue color-nucleus-darkestBlue"
        @input="updateValue"
      >
        <option
          v-for="(option, index) in optionsCommon"
          :key="index"
          :value="option.dial_code"
        >
          {{ option.flag }} {{ option.dial_code }}
          {{ option.name[$root.$i18n.locale] || option.name["en"] }}
        </option>
        <optgroup :label="$t('global.defaults.allCountriesRegions')">
          <option
            v-for="(option, index) in options"
            :key="index"
            :value="option.dial_code"
          >
            {{ option.flag }} {{ option.dial_code }}
            {{ option.name[$root.$i18n.locale] || option.name["en"] }}
          </option>
        </optgroup>
      </select>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["update:value", "updateInputType"],
  props: {
    label: String,
    value: String,
    options: Array,
    optionsCommon: Array,
    id: String,
  },
  data() {
    return {
      isFocused: false,
    };
  },
  methods: {
    // Update Model Value
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateValue(event: any) {
      this.$emit("update:value", event.target.value);
    },
  },
})
export default class Select extends Vue {}
</script>
